
import React from 'react';
import { PartyPopper } from 'lucide-react';
import { useIsMobile } from '@/hooks/use-mobile';

const FormHeader: React.FC = () => {
  const isMobile = useIsMobile();
  
  return (
    <h1 className={`${isMobile ? 'text-base' : 'text-xl'} font-bold mb-4 md:mb-5 text-center bg-clip-text text-transparent bg-gradient-to-r from-blue-600 via-blue-500 to-sky-400 flex items-center justify-center gap-1.5`}>
      <PartyPopper className={`${isMobile ? 'h-5 w-5' : 'h-6 w-6'} text-blue-500`} />
      <span className="leading-tight">Đăng ký tham dự họp mặt cựu học sinh Trường THPT Chuyên Lê Hồng Phong</span>
    </h1>
  );
};

export default FormHeader;
